// extracted by mini-css-extract-plugin
export default {"cookieConsent":"cookieConsent__-1Eur"};